
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hzK4Z", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf; }, function (v) { return $ccb972f8f1c5733b$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ccb972f8f1c5733b$export$f7ad0328861e2f03; }, function (v) { return $ccb972f8f1c5733b$export$f7ad0328861e2f03 = v; });
var $ccb972f8f1c5733b$export$6503ec6e8aabbaf;
var $ccb972f8f1c5733b$export$f7ad0328861e2f03;
"use strict";
var $ccb972f8f1c5733b$var$mapping = new Map();
function $ccb972f8f1c5733b$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$ccb972f8f1c5733b$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $ccb972f8f1c5733b$var$resolve(id) {
    var resolved = $ccb972f8f1c5733b$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$ccb972f8f1c5733b$export$6503ec6e8aabbaf = $ccb972f8f1c5733b$var$register;
$ccb972f8f1c5733b$export$f7ad0328861e2f03 = $ccb972f8f1c5733b$var$resolve;

});

parcelRegister("4m9Pp", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $32c0d72e2f6110e1$export$bdfd709ae4826697; }, function (v) { return $32c0d72e2f6110e1$export$bdfd709ae4826697 = v; });
var $32c0d72e2f6110e1$export$bdfd709ae4826697;
var $32c0d72e2f6110e1$export$c9e73fbda7da57b6;
var $32c0d72e2f6110e1$export$5a759dc7a1cfb72a;
"use strict";
var $32c0d72e2f6110e1$var$bundleURL = {};
function $32c0d72e2f6110e1$var$getBundleURLCached(id) {
    var value = $32c0d72e2f6110e1$var$bundleURL[id];
    if (!value) {
        value = $32c0d72e2f6110e1$var$getBundleURL();
        $32c0d72e2f6110e1$var$bundleURL[id] = value;
    }
    return value;
}
function $32c0d72e2f6110e1$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $32c0d72e2f6110e1$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $32c0d72e2f6110e1$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $32c0d72e2f6110e1$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$32c0d72e2f6110e1$export$bdfd709ae4826697 = $32c0d72e2f6110e1$var$getBundleURLCached;
$32c0d72e2f6110e1$export$c9e73fbda7da57b6 = $32c0d72e2f6110e1$var$getBaseURL;
$32c0d72e2f6110e1$export$5a759dc7a1cfb72a = $32c0d72e2f6110e1$var$getOrigin;

});

parcelRegister("kex29", function(module, exports) {
$parcel$export(module.exports, "GlobalFooter", function () { return (parcelRequire("4Iib2")).GlobalFooter; });
$parcel$export(module.exports, "GlobalFooterBottom", function () { return (parcelRequire("7mqa2")).GlobalFooterBottom; });
parcelRequire("4Iib2");
parcelRequire("gapcI");
parcelRequire("7mqa2");

});
parcelRegister("4Iib2", function(module, exports) {

$parcel$export(module.exports, "GlobalFooter", function () { return $b6bcbc8ba2fac1bb$export$4bf04f8af9c4c55; });
/* global-footer.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");
parcelRequire("iSvIT");

var $dyZbY = parcelRequire("dyZbY");

var $5ohHq = parcelRequire("5ohHq");

var $7mqa2 = parcelRequire("7mqa2");

var $gapcI = parcelRequire("gapcI");
const $b6bcbc8ba2fac1bb$var$globalFooterStyle = null;
const $b6bcbc8ba2fac1bb$var$globalFooterContentContainerStyle = null;
const $b6bcbc8ba2fac1bb$export$4bf04f8af9c4c55 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $dyZbY.default), {
        name: "global-footer-v2",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("footer", {
            className: (0, $esG4f.default)([
                "_4cvr1h6o _11q7cd5j _1e0c1txw _2lx2vrvc _1bah1h6o"
            ]),
            style: {
                "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_bfhkcd5j _1rjcpxbi _1e0c1txw _2lx21bp4 _zulppxbi _1bsb1osq _195g1tcg _dm251txw _10jx1fra _owpuidpf _xtn71wqb"
                ]),
                style: {
                    "--_7zbnls": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $gapcI.GlobalFooterTop), {}),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $7mqa2.GlobalFooterBottom), {
                        selectedLanguage: selectedLanguage,
                        onLanguageChangeHandler: onLanguageChangeHandler
                    })
                ]
            })
        })
    });

});
parcelRegister("7mqa2", function(module, exports) {

$parcel$export(module.exports, "GlobalFooterBottom", function () { return $8845902ca4e16d21$export$8eb5df03385c4090; });
/* global-footer-bottom.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $iSvIT = parcelRequire("iSvIT");

var $f6qj2 = parcelRequire("f6qj2");

var $4wAIt = parcelRequire("4wAIt");

var $fxdfZ = parcelRequire("fxdfZ");

var $gDvNw = parcelRequire("gDvNw");
parcelRequire("8hHsi");
var $cFdkP = parcelRequire("cFdkP");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");
// CSS styling
// ==================================================================
const $8845902ca4e16d21$var$containerStyle = null;
const $8845902ca4e16d21$var$linkStyle = null;
const $8845902ca4e16d21$var$copyrightStyle = null;
const $8845902ca4e16d21$var$linksAndLanguageStyle = null;
const $8845902ca4e16d21$var$listStyle = null; // ==================================================================
// Rendering Functions
// ==================================================================
const $8845902ca4e16d21$var$BottomLinks = ()=>{
    const intl = (0, $f6qj2.default)();
    (0, $iSvIT.useEffect)(()=>{
        var _window_AtlOneTrustWrapper, _window;
        if ((_window = window) === null || _window === void 0 ? void 0 : (_window_AtlOneTrustWrapper = _window.AtlOneTrustWrapper) === null || _window_AtlOneTrustWrapper === void 0 ? void 0 : _window_AtlOneTrustWrapper.updatePolicyLinks) window.AtlOneTrustWrapper.updatePolicyLinks();
    }, []);
    const bottomLinks = [
        {
            text: intl.formatMessage({
                id: "globalfooterv2.bottom.privacy-policy",
                defaultMessage: "Privacy policy"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/privacy-policy"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "globalFooterv2.bottom.notice-at-collection",
                defaultMessage: "Notice at Collection"
            }),
            // eslint-disable-next-line local/ensure-wac-token-usage
            href: "/legal/privacy-policy#additional-disclosures-for-ca-residents",
            isOneTrustWrapped: true
        },
        {
            text: intl.formatMessage({
                id: "globalfooterv2.bottom.terms",
                defaultMessage: "Terms"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/cloud-terms-of-service"),
            isOneTrustWrapped: false
        },
        {
            text: intl.formatMessage({
                id: "globalfooterv2.bottom.impressum",
                defaultMessage: "Impressum"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/legal/impressum"),
            isOneTrustWrapped: false
        }
    ];
    return bottomLinks.map((bottomLink)=>{
        if (bottomLink.isOneTrustWrapped) return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
            className: "link-wrapper atl-policy-link-container",
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cFdkP.LinkWithIcon), {
                linkText: bottomLink.text,
                href: bottomLink.href,
                type: "anchor",
                isHaveIcon: false,
                isUsePlainSpanTagForLinkText: true,
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                    "atl-policy-link"
                ]),
                spanLinkTextClassName: "atl-policy-link-text",
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                }
            })
        }, bottomLink.text);
        else return /*#__PURE__*/ (0, $loA2J.jsx)("li", {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                text: bottomLink.text,
                href: bottomLink.href,
                type: "anchor",
                bgColor: "bgColored",
                className: (0, $esG4f.default)([
                    "_1wybdlk8 _vwz4dlk8 _4t3idlk8 _4bfu1r31 _1hmsglyw _ajmmnqa1 _syaz1hlo _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw"
                ]),
                style: {
                    "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                }
            })
        }, bottomLink.text);
    });
};
const $8845902ca4e16d21$var$copyRightYear = new Date().getFullYear();
const $8845902ca4e16d21$var$containerStyles = null;
const $8845902ca4e16d21$var$labelStyles = null;
const $8845902ca4e16d21$var$arrowStyles = null;
const $8845902ca4e16d21$var$SelectorFallback = ({ selectedLanguage: selectedLanguage })=>{
    var _languages_find;
    const intl = (0, $f6qj2.default)();
    if (!selectedLanguage) selectedLanguage = intl.locale || "en";
    const languageLabel = (_languages_find = (0, $gDvNw.languages).find((lang)=>lang.value === selectedLanguage)) === null || _languages_find === void 0 ? void 0 : _languages_find.label;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_syazvwuj _80omtlke _1e0c116y _4cvr1h6o"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDvNw.LanguageGlobeIcon), {
                color: "#42526e"
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                className: (0, $esG4f.default)([
                    "_ahbq1b66 _1wyboxwj"
                ]),
                children: languageLabel
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("span", {
                "aria-hidden": "true",
                className: (0, $esG4f.default)([
                    "_ahbq1b66 _1wyb1k8s"
                ]),
                children: "\u25BE"
            })
        ]
    });
}; //@ts-ignore

const $8845902ca4e16d21$var$LanguageSelectorLazy = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).lazy(()=>(parcelRequire("4gqYm")).then(({ LanguageSelector: LanguageSelector })=>({
            default: LanguageSelector
        })));
const $8845902ca4e16d21$var$shouldShowFallback = (error)=>{
    return $8845902ca4e16d21$var$isDynamicallyImportedModuleError(error);
};
const $8845902ca4e16d21$var$isDynamicallyImportedModuleError = (error)=>{
    var _error_message, _error_message1;
    return (error === null || error === void 0 ? void 0 : (_error_message = error.message) === null || _error_message === void 0 ? void 0 : _error_message.includes("Failed to fetch dynamically imported module")) || (error === null || error === void 0 ? void 0 : (_error_message1 = error.message) === null || _error_message1 === void 0 ? void 0 : _error_message1.includes("Importing a module script failed"));
};
const $8845902ca4e16d21$export$8eb5df03385c4090 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler, className: className })=>{
    const [isClient, setIsClient] = (0, $iSvIT.useState)(false);
    (0, $iSvIT.useEffect)(()=>{
        setIsClient(true);
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
        name: "global-footer-v2-bottom",
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rjc1tcg _18zrpxbi _1e0c1txw _2lx21bp4 _zulpxy5q _su071ady _19wgxy5q _owpu1tcg _1inivrvc _msup1yb4 _1jsv1h6o",
                className
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    "data-testid": "footer-copyright",
                    className: (0, $esG4f.default)([
                        "_syaz1yg0 _vwz4f6fq _4t3if6fq _1wybdlk8 _10hl1h6o"
                    ]),
                    style: {
                        "--_4cxk3s": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light800"))
                    },
                    children: [
                        "Copyright \xa9 ",
                        $8845902ca4e16d21$var$copyRightYear,
                        " Atlassian"
                    ]
                }),
                /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                    className: (0, $esG4f.default)([
                        "_1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
                            name: "global-footer-v2-bottom-links",
                            children: /*#__PURE__*/ (0, $loA2J.jsx)("ul", {
                                className: (0, $esG4f.default)([
                                    "_2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _2lx21bp4 _zulppxbi _1lp7vrvc _19wgxy5q _q8t51h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($8845902ca4e16d21$var$BottomLinks, {})
                            })
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)((0, $fxdfZ.default), {
                            fallback: /*#__PURE__*/ (0, $loA2J.jsx)($8845902ca4e16d21$var$SelectorFallback, {
                                selectedLanguage: selectedLanguage
                            }),
                            shouldShowFallback: $8845902ca4e16d21$var$shouldShowFallback,
                            children: isClient ? /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                                fallback: /*#__PURE__*/ (0, $loA2J.jsx)($8845902ca4e16d21$var$SelectorFallback, {
                                    selectedLanguage: selectedLanguage
                                }),
                                children: /*#__PURE__*/ (0, $loA2J.jsx)($8845902ca4e16d21$var$LanguageSelectorLazy, {
                                    selectedLanguage: selectedLanguage,
                                    onLanguageChangeHandler: onLanguageChangeHandler
                                })
                            }) : /*#__PURE__*/ (0, $loA2J.jsx)($8845902ca4e16d21$var$SelectorFallback, {
                                selectedLanguage: selectedLanguage
                            })
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("4wAIt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34b6a1a87aed52e8$export$2e2bcd8739ae039; });

var $bOjLV = parcelRequire("bOjLV");
var $34b6a1a87aed52e8$export$2e2bcd8739ae039 = (0, $bOjLV.default);

});
parcelRegister("bOjLV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8993b385ade328ae$export$2e2bcd8739ae039; });

var $1m3mf = parcelRequire("1m3mf");

var $dqOGO = parcelRequire("dqOGO");

var $iSvIT = parcelRequire("iSvIT");

var $5zPyl = parcelRequire("5zPyl");
function $8993b385ade328ae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8993b385ade328ae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8993b385ade328ae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $dqOGO.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8993b385ade328ae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8993b385ade328ae$export$2e2bcd8739ae039(_ref) {
    var name = _ref.name, children = _ref.children;
    var context = (0, $5zPyl.useInteractionContext)();
    var newContext = (0, $iSvIT.useMemo)(function() {
        if (context) return $8993b385ade328ae$var$_objectSpread($8993b385ade328ae$var$_objectSpread({}, context), {}, {
            labelStack: context.labelStack == null ? [
                {
                    name: name
                }
            ] : [].concat((0, $1m3mf.default)(context.labelStack), [
                {
                    name: name
                }
            ])
        });
        else return context;
    }, [
        context,
        name
    ]);
    return context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, $5zPyl.default).Provider, {
        value: newContext
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, null, children);
}

});


parcelRegister("gDvNw", function(module, exports) {

$parcel$export(module.exports, "languages", function () { return $b96c719ad2763658$export$d0d68bb9ed2c643d; });
$parcel$export(module.exports, "LanguageGlobeIcon", function () { return $b96c719ad2763658$export$a7259a7df7627186; });

var $loA2J = parcelRequire("loA2J");
const $b96c719ad2763658$export$d0d68bb9ed2c643d = [
    {
        label: "Deutsch",
        value: "de"
    },
    {
        label: "English",
        value: "en"
    },
    {
        label: "Espa\xf1ol",
        value: "es"
    },
    {
        label: "Fran\xe7ais",
        value: "fr"
    },
    {
        label: "Italiano",
        value: "it"
    },
    {
        label: "\uD55C\uAD6D\uC5B4",
        value: "ko"
    },
    {
        label: "Nederlands",
        value: "nl"
    },
    {
        label: "\u65E5\u672C\u8A9E",
        value: "ja"
    },
    {
        label: "Polski",
        value: "pl"
    },
    {
        label: "Portugu\xeas",
        value: "br"
    },
    {
        label: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        value: "ru"
    },
    {
        label: "\u4E2D\u6587",
        value: "zh"
    }
];
const $b96c719ad2763658$export$a7259a7df7627186 = ({ color: color })=>/*#__PURE__*/ (0, $loA2J.jsxs)("svg", {
        id: "icon-wac-language-globe",
        width: "18px",
        height: "18px",
        viewBox: "0 0 25 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("defs", {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("path", {
                    d: "M2.33514634,13.0909091 C2.80456741,17.1674997 5.87382928,20.4918664 9.91593939,21.5020963 C8.18760918,19.0069673 7.13798566,16.119686 6.87807529,13.0909091 L2.33514634,13.0909091 Z M2.33514634,10.9090909 L6.8751035,10.9090909 C7.12988231,7.89470494 8.18079774,5.00118821 9.91557751,2.49799419 C5.87364609,3.50833206 2.8045534,6.83262197 2.33514634,10.9090909 Z M22.6648537,10.9090909 C22.1954326,6.83250032 19.1261707,3.50813364 15.0840606,2.49790374 C16.8123908,4.99303266 17.8620143,7.88031403 18.1219247,10.9090909 L22.6648537,10.9090909 Z M22.6648537,13.0909091 L18.1248965,13.0909091 C17.8701177,16.1052951 16.8192023,18.9988118 15.0844225,21.5020058 C19.1263539,20.4916679 22.1954466,17.167378 22.6648537,13.0909091 Z M9.15315078,10.9090909 L15.843646,10.9090909 C15.5581939,7.94925479 14.3973512,5.12935736 12.4999751,2.78265622 C10.595448,5.13778492 9.43302782,7.96652031 9.15315078,10.9090909 Z M15.8468492,13.0909091 L9.15635402,13.0909091 C9.44180608,16.0507452 10.6026488,18.8706426 12.5000249,21.2173438 C14.404552,18.8622151 15.5669722,16.0334797 15.8468492,13.0909091 Z M12.5,24 C5.59644063,24 0,18.627417 0,12 C0,5.372583 5.59644063,0 12.5,0 C19.4035594,0 25,5.372583 25,12 C25,18.627417 19.4035594,24 12.5,24 Z",
                    id: "path-1"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                id: "Final-Designs-",
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                    id: "WAC-Language-Banner-Drop-Down-Icon",
                    transform: "translate(-426.000000, -19.000000)",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                        id: "Alert-banner",
                        transform: "translate(-4.000000, 0.000000)",
                        children: /*#__PURE__*/ (0, $loA2J.jsxs)("g", {
                            id: "language-globe-icon",
                            transform: "translate(430.000000, 19.000000)",
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)("mask", {
                                    id: "mask-2",
                                    fill: "#ffffff",
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("use", {
                                        xlinkHref: "#path-1"
                                    })
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                    id: "language-globe-icon-color",
                                    mask: "url(#mask-2)",
                                    fill: color,
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)("g", {
                                        transform: "translate(-1.000000, -1.000000)",
                                        id: "Rectangle",
                                        children: /*#__PURE__*/ (0, $loA2J.jsx)("rect", {
                                            x: "0",
                                            y: "0",
                                            width: "27.2727273",
                                            height: "26.4827586"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });

});

parcelRegister("8hHsi", function(module, exports) {
$parcel$export(module.exports, "LinkWithIcon", function () { return (parcelRequire("cFdkP")).LinkWithIcon; });
parcelRequire("cFdkP");

var $8NmnS = parcelRequire("8NmnS");
parcelRequire("fp4P4");

});
parcelRegister("cFdkP", function(module, exports) {

$parcel$export(module.exports, "LinkWithIcon", function () { return $27f4ffbe24e6fd13$export$e67e718b4b9e91b1; });
/* link-with-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $4XrxY = parcelRequire("4XrxY");
const $27f4ffbe24e6fd13$var$linkWithIconStyle = null;
const $27f4ffbe24e6fd13$var$linkIsUsePlainSpanTagForLinkTextClassStyle = null; /**
                                                          * Return a xs gray icon via iconNAme and linkText. This is specifically used for Global Nav header
                                                          * This is not a WPL approved component, it's an one off. Do not use this anywhere else other than global nav
                                                          * @param formatLinkTextProps
                                                          * @returns
                                                          */ 
const $27f4ffbe24e6fd13$var$formatLinkText = ({ isHaveIcon: isHaveIcon, isCustomIcon: isCustomIcon, iconName: iconName, linkText: linkText })=>{
    const formatLinkStyles = [
        isHaveIcon && null,
        !isHaveIcon && null,
        null
    ];
    const linkIconDivStyle = null;
    const linkTextStyle = null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            isHaveIcon && "_6rthv47k",
            !isHaveIcon && "_6rth14y2",
            "_lcxvglyw _1e0c1txw _4cvr1h6o"
        ]),
        children: [
            isHaveIcon && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3iv47k _1bsb1ul9 _1752v47k"
                ]),
                children: isCustomIcon ? iconName : /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.Icon), {
                    name: iconName,
                    size: "xs",
                    color: "n500"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                className: (0, $esG4f.default)([
                    "_1wybpxbi _vwz4bs82 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: linkText
            })
        ]
    });
}; /**
    * Return an Anchor tag wrapped around formatLinkText specifically used for Global Nav header
    * This is not a WPL approved component, it's an one off. Do not use this anywhere else other than global nav
    * @param LinkWithIconProps
    * @returns
    */ 
const $27f4ffbe24e6fd13$export$e67e718b4b9e91b1 = ({ href: href, type: type, onClick: onClick, className: className, isHaveIcon: isHaveIcon, isCustomIcon: isCustomIcon, iconName: iconName, linkText: linkText, dataEventContainer: dataEventContainer, dataEventColumn: dataEventColumn, isUsePlainSpanTagForLinkText: isUsePlainSpanTagForLinkText = false, spanLinkTextClassName: spanLinkTextClassName })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        className: (0, $esG4f.default)([
            isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _4t3i1ou6 _1e0c116y _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw _1axpoelr _aelyoelr _pb8z1ltp _kj55u7gi _12lvu7gi _4bfu1r31 _1hmsglyw _ajmmnqa1 _11cgyh40",
            !isUsePlainSpanTagForLinkText && "_4cvr1h6o _syazvwuj _vwz4rrl5 _4bfu1r31 _1hmsglyw _ajmmnqa1 _30l3oelr _1up4glyw _16btglyw _1taiglyw _1e0c1ule _s7n4nkob _1axpvwuj _aelyvwuj",
            className
        ]),
        href: href,
        target: type == "external" ? "_blank" : "",
        rel: type == "external" ? "noreferrer" : "",
        onClick: onClick,
        "data-event": "clicked",
        "data-event-component": "linkButton",
        "data-event-container": dataEventContainer,
        "data-event-column": dataEventColumn,
        children: isUsePlainSpanTagForLinkText ? /*#__PURE__*/ (0, $loA2J.jsx)("span", {
            className: spanLinkTextClassName,
            children: linkText
        }) : $27f4ffbe24e6fd13$var$formatLinkText({
            isHaveIcon: isHaveIcon,
            isCustomIcon: isCustomIcon,
            iconName: iconName,
            linkText: linkText
        })
    });
};

});

parcelRegister("8NmnS", function(module, exports) {
/* list-of-links.tsx generated by @compiled/babel-plugin v0.28.8 */ // @ts-ignore

var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");

var $esG4f = parcelRequire("esG4f");

var $iSvIT = parcelRequire("iSvIT");

var $cFdkP = parcelRequire("cFdkP");

var $fp4P4 = parcelRequire("fp4P4");
const $49a2389bd93dcd44$export$e9f30a544b6096f7 = ({ isSideBar: isSideBar, headerText: headerText, listOfLinkWithProps: listOfLinkWithProps })=>{
    const linkListContainerStyle = [
        isSideBar && null,
        !isSideBar && null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            isSideBar && "_1bsb1osq _1e0c1txw _1n261g80 _2lx21bp4 _1aax1e5h _1yt418yu _6rth19bv",
            !isSideBar && "_1bsb1osq _1e0c1txw _1n261g80 _2lx21bp4 _1aax1e5h _1yt415fv _6rth19bv"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $fp4P4.ListOfLinksHeaderText), {
                isSideBar: isSideBar,
                headerText: headerText
            }),
            listOfLinkWithProps.map((listOfLinkWithProp, index)=>{
                const listOfLinkKey = headerText.trim().toLowerCase() + "-" + listOfLinkWithProp.linkText.trim().toLowerCase() + "-" + index.toString();
                return /*#__PURE__*/ (0, $loA2J.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iSvIT))).Fragment, {
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $cFdkP.LinkWithIcon), (0, $7Knp0._)({}, listOfLinkWithProp))
                }, listOfLinkKey);
            })
        ]
    });
};

});
parcelRegister("fp4P4", function(module, exports) {

$parcel$export(module.exports, "ListOfLinksHeaderText", function () { return $5201385287bece10$export$4c59118dc0b93493; });
/* list-of-links-header-text.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
const $5201385287bece10$export$4c59118dc0b93493 = ({ isSideBar: isSideBar, headerText: headerText })=>{
    const headerTextStyle = [
        isSideBar && null,
        !isSideBar && null
    ];
    return /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
        className: (0, $esG4f.default)([
            isSideBar && "_85i5pxbi _1q51o7ao _syazvwuj _18s819a1 _k48pbfng _1wybutpp _vwz4bs82 _1dyzt94y _1p1dangw _1bsb1osq",
            !isSideBar && "_85i5idpf _1q51idpf _syazvwuj _18s819a1 _k48pbfng _1wybutpp _vwz4bs82 _1dyzt94y _1p1dangw _1bsb1osq"
        ]),
        children: headerText.trim().toUpperCase()
    });
};

});



parcelRegister("4gqYm", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("1z79P")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("2waUd")),
    (parcelRequire("frKV3"))((parcelRequire("hzK4Z")).resolve("i3aGO"))
]).then(()=>parcelRequire("fFSAN"));

});
parcelRegister("frKV3", function(module, exports) {
"use strict";

var $jhlcP = parcelRequire("jhlcP");
module.exports = $jhlcP(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(("" + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement("script");
        script.async = true;
        script.type = "module";
        script.charset = "utf-8";
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("jhlcP", function(module, exports) {
"use strict";
var $039f3a07df33262a$var$cachedBundles = {};
var $039f3a07df33262a$var$cachedPreloads = {};
var $039f3a07df33262a$var$cachedPrefetches = {};
function $039f3a07df33262a$var$getCache(type) {
    switch(type){
        case "preload":
            return $039f3a07df33262a$var$cachedPreloads;
        case "prefetch":
            return $039f3a07df33262a$var$cachedPrefetches;
        default:
            return $039f3a07df33262a$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $039f3a07df33262a$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("gapcI", function(module, exports) {

$parcel$export(module.exports, "GlobalFooterTop", function () { return $a36b0616db0c2063$export$38e7ae23a4703911; });
/* global-footer-top.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7Knp0 = parcelRequire("7Knp0");

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $f6qj2 = parcelRequire("f6qj2");

var $4wAIt = parcelRequire("4wAIt");

var $5ohHq = parcelRequire("5ohHq");

var $3FBn4 = parcelRequire("3FBn4");

var $lrVTP = parcelRequire("lrVTP");

var $ehK1w = parcelRequire("ehK1w");
// CSS styling
// ==================================================================
const $a36b0616db0c2063$var$containerStyle = null;
const $a36b0616db0c2063$var$linksWrapperStyle = null;
const $a36b0616db0c2063$export$26b6a80e48da8316 = {
    margin: "0",
    padding: "0",
    border: "0",
    fontSize: "100%",
    verticalAlign: "baseline"
}; // ==================================================================
const $a36b0616db0c2063$export$38e7ae23a4703911 = ()=>{
    const intl = (0, $f6qj2.default)();
    const location = (0, $lrVTP.useLocation)();
    const productsLinkList = {
        headerText: intl.formatMessage({
            id: "globalfooterv2.top.products",
            defaultMessage: "Products"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.rovo",
                    defaultMessage: "Rovo"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/rovo")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.jira-software",
                    defaultMessage: "Jira"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.jira-align",
                    defaultMessage: "Jira Align"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/align")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.jira-service-management",
                    defaultMessage: "Jira Service Management"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/jira/service-management")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.confluence",
                    defaultMessage: "Confluence"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/confluence")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.loom",
                    defaultMessage: "Loom"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/loom")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.trello",
                    defaultMessage: "Trello"
                }),
                href: (0, $3FBn4.useLocalizedHrefTrello)("/home")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.bitbucket",
                    defaultMessage: "Bitbucket"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/software/bitbucket")
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalfooterv2.top.see-all-products",
                defaultMessage: "See all products"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/software"),
            bgColor: "bgWhite"
        }
    };
    const resourcesLinkList = {
        headerText: intl.formatMessage({
            id: "globalfooterv2.top.resources",
            defaultMessage: "Resources"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.technical-support",
                    defaultMessage: "Technical support"
                }),
                href: intl.formatMessage({
                    id: "globalfooterv2.top.technical-support.link",
                    defaultMessage: "https://support.atlassian.com/"
                })
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.purchasing-and-licensing",
                    defaultMessage: "Purchasing & licensing"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/licensing/purchase-licensing")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.atlassian-community",
                    defaultMessage: "Atlassian Community"
                }),
                href: "https://community.atlassian.com/"
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.knowledge-base",
                    defaultMessage: "Knowledge base"
                }),
                href: intl.formatMessage({
                    id: "globalfooterv2.top.knowledge-base.link",
                    defaultMessage: "https://confluence.atlassian.com/kb"
                })
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.marketplace",
                    defaultMessage: "Marketplace"
                }),
                href: "https://marketplace.atlassian.com/"
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.my-account",
                    defaultMessage: "My account"
                }),
                href: "https://my.atlassian.com/products/index"
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalfooterv2.top.create-support-ticket",
                defaultMessage: "Create support ticket"
            }),
            href: "https://support.atlassian.com/contact/",
            bgColor: "bgWhite"
        }
    };
    const learnLinkList = {
        headerText: intl.formatMessage({
            id: "globalfooterv2.top.learn",
            defaultMessage: "Learn"
        }),
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.partners",
                    defaultMessage: "Partners"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/partners")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.training-and-certification",
                    defaultMessage: "Training & certification"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/university")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.documentation",
                    defaultMessage: "Documentation"
                }),
                href: intl.formatMessage({
                    id: "globalfooterv2.top.documentation.link",
                    defaultMessage: "https://confluence.atlassian.com/display/ALLDOC/Atlassian+Documentation"
                })
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.developer-resources",
                    defaultMessage: "Developer resources"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/developers")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.enterprise-services",
                    defaultMessage: "Enterprise services"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/enterprise/services")
            }
        ],
        bottomViewAllLink: {
            text: intl.formatMessage({
                id: "globalfooterv2.top.see-all-resources",
                defaultMessage: "See all resources"
            }),
            href: (0, $3FBn4.useLocalizedHref)("/resources"),
            bgColor: "bgWhite"
        }
    };
    const atlassianLinkList = {
        listOfLinks: [
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.company",
                    defaultMessage: "Company"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/company")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.careers",
                    defaultMessage: "Careers"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/company/careers")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.events",
                    defaultMessage: "Events"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/company/events")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.blogs",
                    defaultMessage: "Blogs"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/blog")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.investor-relations",
                    defaultMessage: "Investor Relations"
                }),
                href: "https://investors.atlassian.com"
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.atlassian-foundation",
                    defaultMessage: "Atlassian Foundation"
                }),
                href: "https://www.atlassianfoundation.org/"
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.press-kit",
                    defaultMessage: "Press kit"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/company/news/press-kit")
            },
            {
                text: intl.formatMessage({
                    id: "globalfooterv2.top.contact-us",
                    defaultMessage: "Contact us"
                }),
                href: (0, $3FBn4.useLocalizedHref)("/company/contact")
            }
        ]
    }; // Adding pdf to french locale for compliance
    if (location.pathname.startsWith("/fr")) atlassianLinkList.listOfLinks.push({
        text: `Index de l'\xe9galit\xe9 professionnelle`,
        // eslint-disable-next-line local/no-non-orangelogic-images-eslint
        href: "https://wac-cdn.atlassian.com/misc-assets/pdfs/2024-France-Gender-Equality-Index.pdf"
    });
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
        name: "global-footer-v2-top",
        children: /*#__PURE__*/ (0, $loA2J.jsx)("div", {
            className: (0, $esG4f.default)([
                "_bfhk1rga _1rjc1tcg _18zrpxbi _2rko16cp _1bsb1osq _p12fsgih _19pk1wug _2hwx1wug _otyr1wug _18u01wug _umua1ady _owpu1tcg"
            ]),
            style: {
                "--_1nu1zxz": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.neutral.light100"))
            },
            children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_nd5lrwmx _1e0c11p5 _yv0ehkll _zulpxy5q _1da71t02 _bcla1tcg _kd3kckbl _1rqt1x32"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $7Knp0._)({}, atlassianLinkList)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $7Knp0._)({}, productsLinkList)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $7Knp0._)({}, resourcesLinkList)),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $ehK1w.LinkListContainer), (0, $7Knp0._)({}, learnLinkList))
                ]
            })
        })
    });
};

});
parcelRegister("ehK1w", function(module, exports) {

$parcel$export(module.exports, "LinkListContainer", function () { return $516896a5764783f3$export$e07e28d16ae87608; });
/* global-footer-top-link-list-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");
var $43MIc = parcelRequire("43MIc");

var $1UUq1 = parcelRequire("1UUq1");

var $5ohHq = parcelRequire("5ohHq");

var $iiTBz = parcelRequire("iiTBz");
// Style Functions
// ==================================================================
const $516896a5764783f3$var$listOfLinksColumnStyle = null;
const $516896a5764783f3$var$listOfLinksUlStyle = null;
const $516896a5764783f3$var$listOfLinksUlLiStyle = null;
const $516896a5764783f3$var$listOfLinksUlLiAnchorTagStyle = null;
const $516896a5764783f3$var$atlassianLinksLiAnchorTagStyle = null;
const $516896a5764783f3$var$headerContainerStyle = null;
const $516896a5764783f3$var$listOfLinksColumnHeaderStyle = null;
const $516896a5764783f3$var$atlassianLogoStyle = null;
const $516896a5764783f3$var$bottomViewAllLinkLiStyle = null;
const $516896a5764783f3$var$bottomViewAllLinkLiAnchorStyle = null; // ==================================================================
const $516896a5764783f3$export$e07e28d16ae87608 = ({ headerText: headerText, listOfLinks: listOfLinks, bottomViewAllLink: bottomViewAllLink })=>{
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_kqswh2mm _1tket94y _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1wyb1osq _s7n41q9y _1e0c1ule _syaz1mpp _vchhusvi _1bsb1osq"
        ]),
        children: [
            headerText ? /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3izwfg _1pfhze3t _6rthxy5q _1e0c1txw _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                    className: (0, $esG4f.default)([
                        "_1wybw1gv _o10x10nf _1p1dangw _syazr2ho _k48p53lb _ect48q0o",
                        "eyebrow-md"
                    ]),
                    style: {
                        "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                    },
                    children: headerText.trim()
                })
            }) : /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_4t3izwfg _6rthxy5q"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iiTBz.LogoLinkContainer), {})
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("ul", {
                className: (0, $esG4f.default)([
                    "_6rthidpf _bozggktf _qtt8glyw"
                ]),
                children: [
                    listOfLinks.map((listOfLink)=>/*#__PURE__*/ (0, $loA2J.jsx)("li", {
                            className: (0, $esG4f.default)([
                                "_6rth8jkm _1pfhze3t _2mzuglyw _ahbq1fm0 _syaz1kw7 _1wyb1j6v _vwz4dlk8"
                            ]),
                            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                                text: listOfLink.text,
                                href: listOfLink.href,
                                type: "anchor",
                                bgColor: "bgWhite",
                                onClick: listOfLink.onClick,
                                className: (0, $esG4f.default)([
                                    "_1wyboxwj _1dyz1a1y _ect4kipj _9oik1r31 _1bnx8stv _jf4cnqa1 _1up4glyw _16btglyw _1taiglyw",
                                    !headerText && "_k48p1fw0 _ect48q0o _1dyz4jg8",
                                    listOfLink.className
                                ])
                            })
                        }, listOfLink.text.trim().replace(" ", "-"))),
                    bottomViewAllLink && /*#__PURE__*/ (0, $loA2J.jsx)("li", {
                        className: (0, $esG4f.default)([
                            "_k48pbfng _1pfhxy5q _2mzuglyw _ahbq1fm0 _1rjcftgi"
                        ]),
                        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1UUq1.Link), {
                            text: bottomViewAllLink.text,
                            href: bottomViewAllLink.href,
                            type: "primary",
                            bgColor: "bgWhite",
                            onClick: bottomViewAllLink.onClick,
                            className: (0, $esG4f.default)([
                                "_syaz1hlo _1wyboxwj _4bfu1r31 _1hmsglyw _ajmmnqa1 _1dyz1a1y _ect4kipj _1a3b1r31 _9oik1r31 _1ydc1r31 _4fpr8stv _1bnx8stv _1x288stv _5goinqa1 _jf4cnqa1 _1726nqa1",
                                bottomViewAllLink.className
                            ]),
                            style: {
                                "--_188070z": (0, $43MIc.default)((0, $5ohHq.wacToken)("color.primary.black"))
                            }
                        })
                    }, bottomViewAllLink.text.trim().replace(" ", "-"))
                ]
            })
        ]
    });
};

});
parcelRegister("iiTBz", function(module, exports) {

$parcel$export(module.exports, "LogoLinkContainer", function () { return $e0414388ff5a3994$export$8a742823b1bccd90; });

var $loA2J = parcelRequire("loA2J");

var $6x1qA = parcelRequire("6x1qA");
var $f6qj2 = parcelRequire("f6qj2");

var $4XrxY = parcelRequire("4XrxY");
const $e0414388ff5a3994$export$8a742823b1bccd90 = ()=>{
    const intl = (0, $f6qj2.default)();
    const messages = (0, $6x1qA.defineMessages)({
        ariaLabelLogo: {
            id: "globalfooterv2.top.logo-label",
            defaultMessage: "Atlassian logo"
        }
    });
    const href = "/wac";
    const dataEvent = "clicked";
    const dataEventComponent = "linkButton";
    const dataEventContainer = "globalFooterV2";
    // const dataProductKey = "TO DO: depends on page"
    return /*#__PURE__*/ (0, $loA2J.jsx)("a", {
        "aria-label": intl.formatMessage(messages.ariaLabelLogo),
        href: href,
        "data-event": dataEvent,
        "data-event-component": dataEventComponent,
        "data-event-container": dataEventContainer,
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4XrxY.LogoV2), {
            brand: "atlassian",
            type: "mark",
            appearance: "brand",
            width: 32,
            height: 32
        })
    });
};

});





parcelRegister("d0cJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9775286909ac5557$var$_react = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("iSvIT")));

var $h5zK0 = parcelRequire("h5zK0");

var $9775286909ac5557$var$_chevronLeft = $9775286909ac5557$var$_interopRequireDefault((parcelRequire("c9BrD")));
function $9775286909ac5557$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9775286909ac5557$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $9775286909ac5557$var$_react.default.createElement($h5zK0.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $9775286909ac5557$var$_chevronLeft.default
    }));
$9775286909ac5557$var$ChevronLeftLargeIcon.displayName = "ChevronLeftLargeIcon";
var $9775286909ac5557$var$_default = module.exports.default = $9775286909ac5557$var$ChevronLeftLargeIcon;

});

parcelRegister("Erp3T", function(module, exports) {
$parcel$export(module.exports, "useProductIntent", function () { return (parcelRequire("kjssF")).useProductIntent; });
parcelRequire("eeJVi");
parcelRequire("kjssF");

});
parcelRegister("eeJVi", function(module, exports) {

$parcel$export(module.exports, "ProductKey", function () { return $638022cbdd0e1e88$export$f3a53bd43617a593; });
$parcel$export(module.exports, "products", function () { return $638022cbdd0e1e88$export$b6aad051bad07f12; });
var $638022cbdd0e1e88$export$f3a53bd43617a593;
(function(ProductKey) {
    ProductKey["JIRA_SOFTWARE"] = "jira-software.ondemand";
    ProductKey["CONFLUENCE"] = "confluence.ondemand";
    ProductKey["JIRA_SERVICE_MANAGEMENT"] = "jira-servicedesk.ondemand";
    ProductKey["JIRA_PRODUCT_DISCOVERY"] = "jira-product-discovery";
})($638022cbdd0e1e88$export$f3a53bd43617a593 || ($638022cbdd0e1e88$export$f3a53bd43617a593 = {}));
const $638022cbdd0e1e88$export$b6aad051bad07f12 = [
    {
        bundle: "jira-software",
        description: "Jira",
        key: "jira-software.ondemand",
        name: "jira"
    },
    {
        bundle: "confluence",
        description: "Confluence",
        key: "confluence.ondemand",
        name: "confluence"
    },
    {
        bundle: "jira-service-management",
        description: "Jira Service Management",
        key: "jira-servicedesk.ondemand",
        name: "jira-servicedesk"
    },
    {
        bundle: "jira-product-discovery",
        description: "Jira Product Discovery",
        key: "jira-product-discovery",
        name: "jira-product-discovery"
    }
];

});

parcelRegister("kjssF", function(module, exports) {

$parcel$export(module.exports, "useProductIntent", function () { return $ead1ccf5e671c3c5$export$93cccec4b411f62; });

var $iSvIT = parcelRequire("iSvIT");

var $eeJVi = parcelRequire("eeJVi");
const $ead1ccf5e671c3c5$export$93cccec4b411f62 = ()=>// eslint-disable-next-line complexity
    (0, $iSvIT.useMemo)(()=>{
        let edition;
        let product;
        if (typeof window === "undefined") return {
            edition: edition,
            product: product
        };
        const params = new URLSearchParams(window.location.search);
        if (window.location.pathname.includes("/software/jira/product-discovery")) {
            product = {
                bundle: "jira-product-discovery",
                description: "Jira Product Discovery",
                key: (0, $eeJVi.ProductKey).JIRA_PRODUCT_DISCOVERY,
                name: "jira-product-discovery"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira/service-management")) {
            product = {
                bundle: "jira-service-management",
                description: "Jira Service Management",
                key: (0, $eeJVi.ProductKey).JIRA_SERVICE_MANAGEMENT,
                name: "jira-servicedesk"
            };
            edition = "free";
        } else if (window.location.pathname.includes("/software/jira")) {
            product = {
                bundle: "jira-software",
                description: "Jira",
                key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                name: "jira"
            };
            edition = "free";
        }
        if (window.location.pathname.includes("/software/confluence")) {
            product = {
                bundle: "confluence",
                description: "Confluence",
                key: (0, $eeJVi.ProductKey).CONFLUENCE,
                name: "confluence"
            };
            edition = "free";
        }
        const isSignupPage = window.location.pathname.endsWith("/try/cloud/signup");
        const isConfirmationPage = window.location.pathname.endsWith("/ondemand/signup/confirmation");
        if (isSignupPage || isConfirmationPage || window.IS_STORYBOOK) {
            // defaults for the signup page
            if (isSignupPage) {
                edition = "free";
                product = {
                    bundle: "jira-software",
                    description: "Jira",
                    key: (0, $eeJVi.ProductKey).JIRA_SOFTWARE,
                    name: "jira"
                };
            }
            // determine product
            if (params.has("product")) product = (0, $eeJVi.products).find((product)=>product.key === params.get("product"));
            else if (params.has("bundle")) product = (0, $eeJVi.products).find((product)=>product.bundle === params.get("bundle"));
            else if (params.has("products")) product = (0, $eeJVi.products).find((product)=>{
                var _params_get;
                return product.key === ((_params_get = params.get("products")) === null || _params_get === void 0 ? void 0 : _params_get.split(",")[0]);
            });
            // determine edition
            const editionParam = params.get("edition");
            if (editionParam === "free") edition = "free";
            else if (editionParam === "standard") edition = "standard";
            else if (editionParam === "premium") edition = "premium";
        }
        return {
            edition: edition,
            product: product
        };
    }, []);

});


var $133b7815257b014c$exports = {};


(parcelRequire("hzK4Z")).register((parcelRequire("4m9Pp")).getBundleURL("94rHl"), JSON.parse('["94rHl","404.7ae40c52.js","i3aGO","language-selector.e5475426.js","2waUd","language-selector.5e567f80.js","1z79P","language-selector.83403737.js"]'));


//# sourceMappingURL=404.7ae40c52.js.map
